import { type JSX } from 'react';

import { ColumnConfig, ColumnType } from 'Components/Table/Columns';
import { Table } from 'Components/Table/Table';
import { OperationalControl } from 'Models/OperationalControls';

export interface ControlListViewProps {
    controls: OperationalControl[];
}

export const ControlListView = (props: ControlListViewProps): JSX.Element => {
    const columns: ColumnConfig<OperationalControl>[] = [
        {
            type: ColumnType.CONTROL,
            name: 'Control',
            getControl: (control) => control,
        },
        {
            type: ColumnType.STRING,
            name: 'Group',
            getString: (control) => control.metadata.control_group_name,
        },
        {
            type: ColumnType.CONTROL_EFFECTIVENESS,
            name: 'Effectiveness',
            getControlEffectiveness: (control) => control.effectiveness.control_effectiveness,
        },
    ];

    return <Table<OperationalControl> columns={columns} defaultSortColumn="Control" filters={[]} getUniqueIdForRow={(control) => control.identifier} rowsData={props.controls} />;
};
